import { Colors } from '@/common/colors/colors';
import Icon from '@/common/components/Icon';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import ToggleSwitch from '@/common/components/ToggleSwitch';
import { CONSULTANT_MANAGER_ROLES } from '@/common/constants/consultantRoles';
import { MONTH_HOURS } from '../constants/monthHoursOptions';

const FormInputs = ({ hook }) => {
	return (
		<>
			<Input
				id='first_name'
				color={Colors.darkBlue}
				name='First name'
				value={hook.formik.values.first_name}
				onChange={hook.formik.handleChange}
				required
				requiredSign
				width={200}
			/>
			<Input
				id='last_name'
				color={Colors.darkBlue}
				name='Last name'
				value={hook.formik.values.last_name}
				onChange={hook.formik.handleChange}
				required
				requiredSign
				width={200}
			/>
			<Input
				id='phone'
				color={Colors.darkBlue}
				name='Phone number'
				value={hook.formik.values.phone}
				onChange={hook.formik.handleChange}
				required
				requiredSign
				width={200}
			/>
			<Input
				id='email'
				color={Colors.darkBlue}
				name='Email address'
				value={hook.formik.values.email}
				onChange={hook.formik.handleChange}
				required
				requiredSign
				width={200}
				type='email'
			/>
			<SelectInput
				color={Colors.darkBlue}
				name='Market'
				options={hook.marketsOptions}
				width={200}
				required
				value={hook.formik.values.market}
				selected={hook.formik.values.market}
				setSelected={(value) => {
					hook.formik.setFieldValue('call_center_position', '');
					hook.formik.setFieldValue('product', '');
					hook.formik.setFieldValue('market', value);
				}}
			/>
			{hook.showProductSelectInput && (
				<SelectInput
					color={Colors.darkBlue}
					name='Product'
					options={hook.productsOptions}
					width={200}
					required
					value={hook.formik.values.product}
					selected={hook.formik.values.product}
					setSelected={(value) => {
						hook.formik.setFieldValue('product', value);
					}}
				/>
			)}
			<SelectInput
				color={Colors.darkBlue}
				name='Call center position'
				disabled={!hook.formik.values.market?.value}
				options={hook.callCenterPositionsOptions.filter(
					(position) => position.market === hook.formik.values.market.value,
				)}
				width={200}
				required
				value={hook.formik.values.call_center_position}
				selected={hook.formik.values.call_center_position}
				setSelected={(value) =>
					hook.formik.setFieldValue('call_center_position', value)
				}
			/>
			<SelectInput
				color={Colors.darkBlue}
				name='Call center manager'
				disabled={hook.selectCallCenterManagerDisabled}
				options={hook.filterUsersByRoles(CONSULTANT_MANAGER_ROLES, true)}
				width={200}
				required
				value={hook.formik.values.call_center_manager}
				selected={hook.formik.values.call_center_manager}
				setSelected={(value) =>
					hook.formik.setFieldValue('call_center_manager', value)
				}
			/>
			<Input
				name='CV'
				color={Colors.darkBlue}
				type='file'
				width={200}
				inputRef={hook.cvRef}
				required={hook.selectedCandidate?._id ? false : true}
				requiredSign={hook.selectedCandidate?._id ? false : true}
			/>
			{hook.selectedCandidate.cv && (
				<p
					onClick={() => hook.handleGetStoredDocument()}
					style={{
						gap: '8px',
						display: 'flex',
						alignItems: 'center',
						cursor: 'pointer',
						width: 'fit-content',
						float: 'right',
					}}
				>
					<span style={{ color: Colors.darkGray2 }}>download CV</span>
					<Icon
						color={Colors.green}
						name={
							hook.isFileLoading ? 'spin' : 'download'
						}
						spin={hook.isFileLoading}
					/>
				</p>
			)}
			<ToggleSwitch
				name='has_headset'
				onChange={hook.formik.handleChange}
				text='Has headset:'
				width={210}
				checked={hook.formik.values.has_headset}
			/>
			<SelectInput
				options={MONTH_HOURS}
				color={Colors.darkBlue}
				name='Month hours'
				value={hook.formik.values.month_hours}
				setSelected={(value) => hook.formik.setFieldValue('month_hours', value)}
				selected={hook.formik.values.month_hours}
				type='number'
				width={200}
			/>
			<Input
				id='possible_start_date'
				color={Colors.darkBlue}
				name='Possible start date'
				value={hook.formik.values.possible_start_date}
				onChange={hook.formik.handleChange}
				type='date'
				width={200}
			/>
		</>
	);
};

export default FormInputs;
